import { ITicket } from '@@sapporo/ticket/interface/ITicket';
import ProductBadges from '@/components/Common/Badge/ProductBadges';
import ImageFallback from '@/components/Common/ImageFallback/ImageFallback';
import SunnyLink from '@/components/Common/SunnyLink';
import { formatDistance, getLeisureDetailHref } from '@/utils/domain/leisure';
import clsx from 'clsx';
import React, { useMemo } from 'react';

import LeisureBadges from '../Badges/LeisureCommonBadges';
import PriceDiscount from '../PriceDiscount/LeisurePriceDiscount';
import PriceOrigin from '../PriceOrigin/LeisurePriceOrigin';
import styles from './LeisureListItem.module.scss';
import { ITicketV3 } from '@/models/Leisure/interfaces/payloads/ILeisureProductsPayload';
import { pipe } from 'ramda';

interface ILeisureListItemProps {
  item: ITicket | ITicketV3;
  onClick?: React.MouseEventHandler;
  placeNo?: number;
  // href 링크를 비활성화 할지 여부
  disableHref?: boolean;
}

/**
 * 레저 리스트 기본형 아이템.
 */
const LeisureListItem: React.FC<ILeisureListItemProps> = ({
  item,
  onClick = () => {
    return;
  },
  placeNo,
  disableHref = false,
}) => {
  const isOnSale = item.status.type === 'SALE';
  const distance = item.position.distance;

  const href = useMemo(() => {
    return disableHref ? undefined : getLeisureDetailHref(item);
  }, [disableHref, item]);

  return (
    <SunnyLink
      className={styles.container}
      href={href}
      onClick={pipe(onClick, () => {
        if (!disableHref) return;
        window.location.href = getLeisureDetailHref(item);
      })}
      data-test="leisureListItem"
    >
      <ImageFallback className={styles.image} src={item.image.cover} />
      <div className={styles.body}>
        <ProductBadges badges={item.eventBadges} className={styles.productBadges} />
        <p className={clsx(styles.title, !isOnSale && styles.dimmed)}>{item.title}</p>
        {distance && isOnSale ? (
          <p className={styles.distance}>
            {!placeNo ? '내위치로부터 ' : '숙소로부터 '}
            {formatDistance(distance)}
          </p>
        ) : (
          <p className={styles.desc}>{item.desc}</p>
        )}
        {isOnSale && <LeisureBadges className={styles.badges} item={item} />}
        <div className={styles.priceWrap}>
          <PriceOrigin item={item} />
          <PriceDiscount item={item} exposeRate={true} />
        </div>
      </div>
    </SunnyLink>
  );
};

export default LeisureListItem;
